<div [ngClass]="{'animated flipInY': true}">
  <div class="login-header">Reset Password</div>

  <div class="login-body">
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="resetPassword()">
      <div class="form-group">
        <input type="email" class="form-control" formControlName="email" placeholder="Email" (keyup)="clearErrors()">
      </div>

      <a class="login-button" (click)="resetPassword()" [class.disabled]="isLoading">
        <span *ngIf="!isLoading">Reset Password</span>
        <div *ngIf="isLoading" class="login-loader"></div>
      </a>
    </form>
  </div>

  <div class='message-wrapper'>
    <div *ngIf="showInvalidEmailError" class='message-error'>
      Please input valid email
    </div>

    <div *ngIf="showEmailNotFoundError" class='message-error'>
      Email not found. Please register.
    </div>

    <div *ngIf="showResetFailedError" class='message-error'>
      An error occurred. Please, contact the administrator.
    </div>

    <div *ngIf="isSuccess && successMessage()" class='message-success'>
      {{ successMessage() }}
    </div>
  </div>

  <div class="login-footer">
    <a (click)="cancel()" class="link-button">Cancel</a>
  </div>
</div>